import React, { useContext, useState, useEffect, useRef } from 'react';
import { Button, Input, DatePicker, Form, Select, Checkbox, Switch, InputNumber } from 'antd'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import styles from '../../services/styles'
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages'
import dayjs from 'dayjs';

const { Option } = Select
const { RangePicker } = DatePicker

// Opções de filtro de status do plano
const PLAN_STATUS_OPTIONS = [
    { value: '', label: 'Todos' },
    { value: 'active', label: '✓ Planos Ativos' },
    { value: 'expired', label: '✗ Planos Expirados' },
    { value: 'expiring_soon', label: '⚠ Expira em breve' },
]

export default function UserFilters(props) {
    const [form] = Form.useForm()
    // const [currentFilters, setCurrentFilters] = useState({})
    const [clients, setClients] = useState([])
    let clientsList = []
    const {
        mobile_mode,
        windowWidth
    } = useContext(GeneralContext)

    useEffect(() => {
        loadClientList()
    }, [])


    const handleOnClearFilter = () => {
        form.resetFields()
    }

    const loadClientList = async () => {
        try {
            clientsList = await api.client.list()
            setClients(clientsList.data)
        } catch (error) {
            console.log(error)
        }
    }


    const onSubmitForm = (values) => {
        // Processar datas do range picker
        if (values.date_range && values.date_range.length === 2) {
            values.start_date = dayjs(values.date_range[0]?.$d)?.format('DD/MM/YYYY')
            values.end_date = dayjs(values.date_range[1]?.$d)?.format('DD/MM/YYYY')
        } else {
            values.start_date = null
            values.end_date = null
        }
        delete values.date_range

        // Processar filtro de status do plano
        if (values.plan_status === 'active') {
            values.only_active_plan = true
        } else if (values.plan_status === 'expired') {
            values.only_expired_plan = true
        } else if (values.plan_status === 'expiring_soon') {
            values.expires_within_days = values.expires_within_days || 7
        }
        delete values.plan_status
        
        props.onSearchUsers(values)
    }

    const windowBreakpoint = windowWidth < 800 //px

    return (

        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    color: 'white',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 gap-1'>
                <span className='self-center font-bold text-lg text-fit-gray-600 flex-1 text-center'>Filtros da Consulta</span>
            </div>

            <div className={'bg-fit-gray-100 flex flex-col justify-between p-2'}>
                <Form
                    form={form}
                    className={`flex flex-1 flex-col min-w-fit gap-4 flex-wrap`}
                    layout='inline'
                    onFinish={onSubmitForm}
                >
                    <div className='flex w-full gap-4 lg:gap-6 flex-wrap'>
                        {/* Filtros básicos */}
                        <div className='flex flex-col gap-2'>
                            <div style={{ width: '260px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span className='font-bold text-fit-red-900'>{displayMessage('NAME')}:</span>
                                <Form.Item initialValue={''} label={''} noStyle={true} className='m-0 flex-1' name={'by_name'} >
                                    <Input className='ss:w-[200px]' placeholder="Buscar por nome" />
                                </Form.Item>
                            </div>

                            <div style={{ width: '260px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span className='font-bold text-fit-red-900'>{displayMessage('EMAIL')}:</span>
                                <Form.Item initialValue={''} noStyle={true} className='m-0 flex-1' name={'by_email'} label={''}>
                                    <Input className='ss:w-[200px]' placeholder="Buscar por email" />
                                </Form.Item>
                            </div>
                        </div>

                        {/* Filtros de expiração */}
                        <div className='flex flex-col gap-2'>
                            <div style={{ width: '280px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span className='font-bold text-fit-red-900'>Status Plano:</span>
                                <Form.Item initialValue={''} noStyle={true} className='m-0' name={'plan_status'}>
                                    <Select style={{ width: 180 }} placeholder="Selecione">
                                        {PLAN_STATUS_OPTIONS.map(opt => (
                                            <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>

                            <div style={{ width: '280px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span className='font-bold text-fit-red-900'>Expira em:</span>
                                <Form.Item initialValue={7} noStyle={true} className='m-0' name={'expires_within_days'}>
                                    <InputNumber 
                                        style={{ width: 180 }} 
                                        min={1} 
                                        max={365} 
                                        addonAfter="dias"
                                        placeholder="Ex: 7"
                                    />
                                </Form.Item>
                            </div>
                        </div>

                        {/* Filtro por período de validade */}
                        <div className='flex flex-col gap-2'>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                <span className='font-bold text-fit-red-900'>Período de Validade:</span>
                                <Form.Item noStyle={true} className='m-0' name={'date_range'}>
                                    <RangePicker 
                                        format={'DD/MM/YYYY'}
                                        placeholder={['Data inicial', 'Data final']}
                                        style={{ width: 280 }}
                                    />
                                </Form.Item>
                            </div>
                        </div>

                        {/* Botões */}
                        <div className='flex flex-col ss:flex-row flex-1 flex-wrap gap-1 justify-end items-end'>
                            <Button
                                htmlType='submit'
                                type="primary"
                                className='w-full ss:max-w-[200px] flex-1 font-bold rounded-md'
                            >
                                {displayMessage('SEARCH')}
                            </Button>

                            <Button
                                className='w-full ss:max-w-[200px] flex-1 font-bold rounded-md'
                                type="primary"
                                danger={true}
                                onClick={handleOnClearFilter}
                            >
                                {displayMessage('CLEAN_FILTERS')}
                            </Button>
                        </div>
                    </div>

                </Form>
            </div>
        </div >
    )
}


